var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Section",
    _vm._b(
      {
        attrs: {
          title: "Activity Types",
          shouldShowSearch: _vm.shouldShowSearch,
          toolbarActions: _vm.toolbarActions,
          icon: "event",
          isLoading: _vm.isLoading,
        },
        on: {
          onClicked: (val) => _vm.$emit(val),
          onShouldSearch: (val) => (_vm.searchText = val),
        },
      },
      "Section",
      _vm.$attrs,
      false
    ),
    [
      _c("v-data-table", {
        staticClass: "elevation-1",
        attrs: {
          headers: _vm.headers,
          items: _vm.activityTypeList,
          search: _vm.searchText,
          "item-key": "id",
          "rows-per-page-items": [15, 25, 50, 100],
        },
        scopedSlots: _vm._u([
          {
            key: "items",
            fn: function (props) {
              return [
                _c("td", { staticClass: "text-xs-left" }, [
                  _vm._v(_vm._s(props.item.name)),
                ]),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "text-xs-left" },
                  [
                    _c(
                      "v-icon",
                      {
                        attrs: {
                          color: props.item.isStatusChange ? "green" : "red",
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(props.item.isStatusChange ? "done" : "close")
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "text-xs-left" },
                  [
                    _c(
                      "v-icon",
                      {
                        attrs: {
                          color: props.item.isLocationChange ? "green" : "red",
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(props.item.isLocationChange ? "done" : "close")
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "text-xs-left" },
                  _vm._l(props.item.assetStatusIds, function (assetStatusId) {
                    return _c(
                      "v-chip",
                      {
                        key: assetStatusId,
                        attrs: { disabled: _vm.isLoading },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              "" +
                                _vm._entityPropertyValueByName({
                                  entityList: _vm.assetStatusList,
                                  idKey: "id",
                                  idValue: assetStatusId,
                                  propertyKey: "name",
                                })
                            ) +
                            "\n        "
                        ),
                      ]
                    )
                  }),
                  1
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "text-xs-left" },
                  [
                    _c(
                      "v-icon",
                      {
                        attrs: {
                          color: props.item.isEnabled ? "green" : "red",
                        },
                      },
                      [_vm._v(_vm._s(props.item.isEnabled ? "done" : "close"))]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "text-xs-right" },
                  [
                    _c("ControlButton", {
                      attrs: {
                        text: "Edit",
                        icon: "edit",
                        iconColor: "warning",
                        disabled: _vm.isLoading,
                      },
                      on: {
                        onClicked: function ($event) {
                          return _vm.$emit("onEditActivityTypeClicked", {
                            activityTypeToEdit: props.item,
                          })
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }